import { useSelector } from "react-redux";
import { FaCheck } from "react-icons/fa";

const StepNavigation = ({ steps, currentStep }) => {
  const streamingStatus = useSelector(
    (state) => state?.videoStreamData?.IPCameraVideoStreamingStatus
  );
  return (
    <div className="">
      <div className="stepper-wrapper mg-bottom-20">
        <div
          className={`stepper-item ${currentStep != 0 && "completed"} ${
            currentStep === 0 && "active"
          }`}
        >
          <div className="step-counter">
            {currentStep != 0 ? <FaCheck className="white" /> : "1"}
          </div>
          <div className="step-name semi-bold fs-16 noWrap">
            Select Opponent
          </div>
        </div>

        <div
          className={`stepper-item ${currentStep > 1 && "completed"} ${
            currentStep === 1 && "active"
          }`}
        >
          <div className="step-counter">
            {currentStep > 1 ? <FaCheck className="white" /> : "2"}
          </div>
          <div className="step-name semi-bold fs-16 noWrap">Select Season</div>
        </div>

        <div
          className={`stepper-item ${
            currentStep === 2 ? (streamingStatus ? "completed" : "active") : ""
          }`}
        >
          <div className="step-counter">
            {streamingStatus ? <FaCheck className="white" /> : "3"}
          </div>
          <div className="step-name semi-bold fs-16">Select Angle</div>
        </div>
      </div>
    </div>
  );
};

export default StepNavigation;
